import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, finalize, map } from "rxjs/operators";
import { Globals } from "../../app.globals";

@Injectable()
export class GeneratorService {
    private apiUrl = "/api/settings/codegenerator";

    constructor(public http: HttpClient, private globals: Globals) {}

    get(type: string): Observable<Code> {
        this.showSpinner();
        return this.http.get(this.apiUrl + "/" + type).pipe(
            map((res) => res as Code),
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    getNext(type: string): Observable<NextCode> {
        this.showSpinner();
        return this.http.get(this.apiUrl + "/" + type + "/generate").pipe(
            map((res) => res as NextCode),
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    add(code: Code): Observable<any> {
        this.showSpinner();
        return this.http.post(this.apiUrl, Code.map(code)).pipe(
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    update(id: number, code: Code): Observable<any> {
        this.showSpinner();
        return this.http.put(this.apiUrl + "/" + id, Code.map(code)).pipe(
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    private handleError(error: Response): Observable<any> {
        return throwError(
            error || "Server error, please refresh and try again"
        );
    }

    private showSpinner() {
        this.globals.showSpinner();
    }

    private hideSpinner() {
        this.globals.hideSpinner();
    }
}

class Code {
    id: number;
    type: string;
    start: string;
    separator: string;
    end: string;
    baseCode: string;
    baseStart: string;
    baseEnd: string;
    active: boolean;

    static map(value: any): Code {
        return {
            active: value.active,
            baseCode: value.baseCode,
            baseEnd: value.baseEnd,
            baseStart: value.baseStart,
            end: value.end,
            id: value.id,
            separator: value.separator,
            start: value.start,
            type: value.type,
        };
    }
}

export class NextCode {
    active: boolean;
    nextCode: string;
}
